module.exports = __webpack_public_path__ + "img/logo_difunde.ea603c28.svg";